import ModularHeader from './ModularHeader';

export default ModularHeader;
